export const getUnidades = (state) => state.unidades.lista
export const getTotalUnidades = (state) => state.unidades.total
export const getIsCarregandoListaUnidades = (state) => state.unidades.isCarregandoLista
export const getUnidadeSelecionada = (state) => state.unidades.unidadeSelecionada
